module.exports = __webpack_public_path__ + "img/card_img_4.945d1cec.png";